export default function LiveBadgeButton({
	children,
}: { children?: React.ReactNode }) {
	return (
		<button
			type="button"
			className="relative inline-flex w-12 items-center gap-2 px-1.5 py-0.5 rounded-2xl bg-primary/20 text-red-500 shadow-lg hover:shadow-xl transition"
		>
			{children}

			{/* Live badge */}
			<span className="relative flex items-center gap-1 text-[11px] font-bold text-red-500">
				<span className="relative flex h-2 w-2">
					{/* Ping animation */}
					<span className="absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75 animate-ping" />
					<span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" />
				</span>
				LIVE
			</span>
		</button>
	);
}
